import { useEffect, useState } from 'react';
import styles from './UserGroupAddCard.module.css';
import Styles from '../GroupChatScreen/AddGroupUsersModal/AddGroupUsersMoal.module.css';

const AV_COLORS = ['#800020', '#7c3aed', '#065f46', '#b45309', '#1d4ed8', '#9d174d'];
const getAvColor = name => AV_COLORS[(name?.charCodeAt(0) || 0) % AV_COLORS.length];
const getInitials = name => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  return parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : parts[0].slice(0, 2).toUpperCase();
};

const UserGroupAddCard = ({ setCheckboxes, checkboxes, isChecked, setIsChecked, name, email, handleCheckboxToggle, id, loading }) => {
  const [checked, setChecked] = useState(false);
  const [isLoading, setLoading] = useState(true);

  const handleCheckboxChange = () => {
    handleCheckboxToggle({
      name: name,
      email: email,
      id: id,
    });
    setChecked(!checked);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <div className={styles.card} style={{ padding: '6px 12px' }}>
      {isLoading ? (
        <div className={`${styles.cards}`}>
          <div className={`${styles.card_title} ${styles.loading}`}></div>
        </div>
      ) : (
        <>
          <div className={`${Styles.userRow} ${checked ? Styles.userRowSelected : ''}`} onClick={handleCheckboxChange} style={{ width: '100%' }}>
            <div className={Styles.userAv} style={{ background: getAvColor(name) }}>
              {getInitials(name)}
            </div>
            <div className={Styles.userInfo}>
              <span className={Styles.userName}>{name}</span>
              <span className={Styles.userEmail}>{email}</span>
            </div>
            <div className={`${Styles.checkbox} ${checked ? Styles.checkboxChecked : ''}`}>
              {checked && (
                <svg width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='#ffffff' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
                  <polyline points='20 6 9 17 4 12' />
                </svg>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserGroupAddCard;
